module.exports = __webpack_public_path__ + "static/media/bkg.b533d77d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/icons/bkg.svg
// module id = 1073
// module chunks = 0